import { User } from "@/features/system/types";

import { getAnalyticsUserRole } from "@/utils/getAnalyticsUserRole";

type HeapClient = {
  identifyHashed: (identity: string) => void;
  addUserProperties: (properties: Record<string, string>) => void;
  resetIdentity: () => void;
};

function getHeap(): HeapClient | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (window as Window & { heap?: HeapClient }).heap;
}

export function identifyHeapUser(currentUser: User) {
  const heap = getHeap();
  if (!heap || !currentUser.email) {
    return;
  }

  // Heap SHA-256-hashes the identity client-side before sending it.
  heap.identifyHashed(currentUser.email);
  heap.addUserProperties({
    role: getAnalyticsUserRole(currentUser.email),
    company: currentUser.orgName,
  });
}

export function resetHeapIdentity() {
  getHeap()?.resetIdentity();
}
